export const CURRENCY = {
  AZN: '₼',
  USD: '$',
  EUR: '€',
  RUB: '₽',
  TRY: '₺',
}
